import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';

// material-ui
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// ==============================|| SIDEBAR MENU LIST ITEM (MUI DEFAULT BASELINE) ||============================== //

const NavItem = ({ item, level }) => {
  const location = useLocation();

  const Icon = item.icon;
  const itemIcon = item?.icon ? (
    <Icon stroke={1.5} size="1.3rem" />
  ) : (
    <FiberManualRecordIcon fontSize={level > 0 ? 'inherit' : 'medium'} />
  );

  return (
    <ListItemButton
      component={NavLink}
      to={item.url}
      target={item.target ? '_blank' : '_self'}
      disabled={item.disabled}
      selected={location.pathname === item.url}
    >
      <ListItemIcon>{itemIcon}</ListItemIcon>
      <ListItemText primary={item.title} />
      {item.chip && (
        <Chip
          color={item.chip.color}
          variant={item.chip.variant}
          size={item.chip.size}
          label={item.chip.label}
          avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
        />
      )}
    </ListItemButton>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number
};

export default NavItem;

